import { render, staticRenderFns } from "./RelateInvoiceToTreasuryAccountModal.vue?vue&type=template&id=ca75fd6e"
import script from "./RelateInvoiceToTreasuryAccountModal.vue?vue&type=script&lang=js"
export * from "./RelateInvoiceToTreasuryAccountModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca75fd6e')) {
      api.createRecord('ca75fd6e', component.options)
    } else {
      api.reload('ca75fd6e', component.options)
    }
    module.hot.accept("./RelateInvoiceToTreasuryAccountModal.vue?vue&type=template&id=ca75fd6e", function () {
      api.rerender('ca75fd6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/RelateInvoiceToTreasuryAccountModal.vue"
export default component.exports